import { assertString } from './util/assertString'

export function toFloat(str) {
  assertString(str)
  return parseFloat(str)
}
